<script setup>
import WindlistPage from '@/components/WindlistPage.vue';
import ToastHost from '@/components/base/ToastHost.vue';

</script>

<template>
  <Suspense>
    <WindlistPage />
  </Suspense>
  <ToastHost />
</template>
